module.exports = __webpack_public_path__ + "annualreview2017/static/img/pie.ec37496.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transparency/pie.png
// module id = 162
// module chunks = 0